module.exports = __webpack_public_path__ + "img/recommended.177d6f20.png";